/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import { AnyAction } from 'redux';
import { AUTH_LOGOUT } from '../../../constants/auth.constants';
import { SET_GROUPS, SET_ROLES, SET_STATES, SET_STATUSES } from '../../../constants/enums.constants';
import EnumsState from '../../../models/redux/state/enums.state';

const initialState: EnumsState = {
  roles: [],
  states: [],
  groups: [],
  statuses: [],
};

const enumsReducer = produce((draft: EnumsState, action: AnyAction) => {
  switch (action.type) {
    case SET_ROLES:
      draft.roles = action.roles;
      break;
    case SET_STATES:
      draft.states = action.states;
      break;
    case SET_GROUPS:
      draft.groups = action.groups;
      break;
    case SET_STATUSES:
      draft.statuses = action.statuses;
      break;
    case AUTH_LOGOUT:
      draft.roles = initialState.roles;
      draft.states = initialState.states;
      draft.groups = initialState.groups;
      draft.statuses = initialState.statuses;
      break;
    default:
  }
}, initialState);

export default enumsReducer;
